import { useMutation, useQuery, useQueryClient } from 'react-query';
import { APIErrorType } from '../../api';
import {
  createStudent,
  CreateStudentDataType,
  fetchStudent,
  StudentType,
  updateStudent,
  UpdateStudentDataType
} from '../../api/student';
import { UseQueryResult } from 'react-query/types/react/types';

export type useStudentReturnType = UseQueryResult<StudentType>;

export function useStudent(enabled: boolean = true): useStudentReturnType {
  return useQuery<StudentType, APIErrorType>('student', fetchStudent, {
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false
  });
}

export function useCreateStudentMutation() {
  const queryClient = useQueryClient();

  return useMutation<StudentType, APIErrorType, CreateStudentDataType>(createStudent, {
    onSuccess: student => {
      queryClient.setQueryData('student', student);
    }
  });
}

export function useUpdateStudentMutation() {
  const queryClient = useQueryClient();

  return useMutation<StudentType, APIErrorType, UpdateStudentDataType>(updateStudent, {
    onSuccess: student => {
      queryClient.setQueryData('student', student);
    }
  });
}
